<template>
    <div v-if="open" id="quiz-type-select-modal">
        <div :class="[{ 'modal fade px-4': true, show: open }]" id="quiz-type-select">
            <div @click="closeModal()" class="bg-backdrop absolute w-full h-full"></div>
            <div class="modal-content w-full">
                <div class="modal-header flex justify-between items-center p-4 w-full fixed sticky">
                    <h3 class="m-0 shadow-text-none">{{ $t('setting_modal_header_select_type') }}</h3>
                    <div @click="closeModal()" class="close-btn-box flex justify-center items-center">
                        <i class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="type-select-box flex p-4">
                        <XButton
                            @click="selectQuizType('quiz')"
                            class="flex-1 system-button-color system-button-text-color shadow-text-none"
                        >
                            <i class="fas fa-question-circle"></i>
                            <span>{{ $t('setting_quiz') }}</span>
                        </XButton>
                        <!-- <XButton
                                @click="selectQuizType('poll')"
                                class="flex-1 system-button-color system-button-text-color shadow-text-none"
                            >
                                <i class="fas fa-poll"></i>
                                <span>{{ $t('setting_poll') }}</span>
                            </XButton> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import XButton from '@/components/v2/XButton'

export default {
    props: {
        open: {
            type: Boolean,
            default: true
        }
    },

    components: {
        XButton
    },

    methods: {
        closeModal() {
            this.$emit('close')
        },

        selectQuizType(type) {
            this.$emit('select-quiz-type', type)
        }
    }
}
</script>

<style lang="scss">
#quiz-type-select-modal {
    .modal {
        background-color: rgba(0, 0, 0, 0);
        transition: background-color 0.3s ease-out;

        &.show {
            background-color: rgba(0, 0, 0, 0.5);
            animation: fadeBg 0.3s ease-out;

            > .modal-content {
                opacity: 1;
                transform: translateY(0px);
                animation: showModal 0.3s ease-out;
            }
        }

        > .bg-backdrop {
            top: 0;
            left: 0;
        }

        > .modal-content {
            border-radius: 4px;
            background-color: #fff;
            transform: translateY(-50px);
            opacity: 0;
            transition: transform 0.3s ease-out, opacity 0.3s ease-out;

            @media screen and (min-width: 768px) {
                width: 90%;
                height: 90%;
            }

            .modal-header {
                border-bottom: 1px solid #ccc;
            }

            .modal-body {
                .input,
                .textarea {
                    padding: 0.375rem 0.75rem;
                    border: 1px solid #ccc;
                    font-size: 1rem;
                    font-weight: 400;
                    color: #000;
                    text-shadow: none;
                }

                .input {
                    height: 40px;
                }
            }

            .modal-footer {
                border-top: 1px solid #ccc;
            }
        }
    }

    #quiz-type-select {
        > .modal-content {
            max-width: 500px;
            height: auto !important;

            .modal-body {
                .type-select-box {
                    column-gap: 1rem;
                }
            }
        }
    }
}
</style>
